import axios from "axios";

let apiHost = ``;
if (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === "local") {
  apiHost = `http://localhost:4000/api`;
} else if (process.env.REACT_APP_ENV === "dev") {
  apiHost = `https://staging.api.ruebarue.com/dev/api`;
} else if (process.env.REACT_APP_ENV === "staging") {
  apiHost = `https://4t7cwt8tyk.execute-api.us-east-2.amazonaws.com/staging/api`;
} else if (process.env.REACT_APP_ENV === "prod") {
  apiHost = `https://api.staging.ruebarue.com/beta/api`;
}

// Allow an isolated localhost checkout to use its own same-origin API proxy.
if (process.env.REACT_APP_API_HOST) {
  apiHost = process.env.REACT_APP_API_HOST.replace(/\/$/, "");
}

let apiHostForChatbot = ``;
if (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === "local") {
  apiHostForChatbot = `http://localhost:4001/api`;
} else if (process.env.REACT_APP_ENV === "dev") {
  // apiHostForChatbot = `https://4t7cwt8tyk.execute-api.us-east-2.amazonaws.com/dev/api`;
} else if (process.env.REACT_APP_ENV === "staging") {
  // apiHostForChatbot = `https://4t7cwt8tyk.execute-api.us-east-2.amazonaws.com/staging/api`;
} else if (process.env.REACT_APP_ENV === "prod") {
  apiHostForChatbot = `https://chatbot.ruebarue.com/prod/api`;
}

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const buildAuthHeaders = () => {
  const token = getCookie("api_token");
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

const axiosInstance = axios.create({
  headers: buildAuthHeaders(),
  withCredentials: false,
  baseURL: `${apiHost}/v1`,
});

const axiosInstanceV2 = axios.create({
  headers: buildAuthHeaders(),
  withCredentials: true,
  baseURL: `${apiHost}/v2`,
});

const refreshAuthHeaders = (config) => {
  // Cookie may have been set after the instance was created (e.g. after
  // login) — re-read on every request and strip a stale Authorization
  // header when the cookie is gone (avoids sending "Bearer undefined").
  const token = getCookie("api_token");

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers) {
    delete config.headers.Authorization;
    delete config.headers.authorization;
  }
  return config;
};

axiosInstanceV2.interceptors.request.use(refreshAuthHeaders);

const axiosInstanceForChatbot = axios.create({
  headers: buildAuthHeaders(),
  withCredentials: true,
  baseURL: process.env.REACT_APP_AI_API_HOST || apiHostForChatbot,
});

// The AI client is initialized when the app bundle loads, which can happen
// before login has set the API token. Always attach the current token so AI
// actions work without requiring a full page refresh after signing in.
axiosInstanceForChatbot.interceptors.request.use(refreshAuthHeaders);

export default axiosInstance;
export const httpV2 = axiosInstanceV2;
export const host = apiHost;
export const httpAI = axiosInstanceForChatbot;
